'use client';
import React, { useState, useMemo, useEffect } from 'react';

interface Word {
  id: string;
  fr: string;
  en: string;
  phonetic: string;
  category: string;
}

const WORDS: Word[] = [
  // SALUTATIONS
  { id: 'w-sal-01', fr: 'Bonjour', en: 'Hello', phonetic: 'hɛˈloʊ', category: 'Salutations' },
  { id: 'w-sal-02', fr: 'Au revoir', en: 'Goodbye', phonetic: 'ˌɡʊdˈbaɪ', category: 'Salutations' },
  { id: 'w-sal-03', fr: 'Merci', en: 'Thank you', phonetic: 'θæŋk juː', category: 'Salutations' },
  { id: 'w-sal-04', fr: "S'il vous plaît", en: 'Please', phonetic: 'pliːz', category: 'Salutations' },
  { id: 'w-sal-05', fr: 'Excusez-moi', en: 'Excuse me', phonetic: 'ɪkˈskjuːz miː', category: 'Salutations' },
  { id: 'w-sal-06', fr: 'Oui', en: 'Yes', phonetic: 'jɛs', category: 'Salutations' },
  { id: 'w-sal-07', fr: 'Non', en: 'No', phonetic: 'noʊ', category: 'Salutations' },
  { id: 'w-sal-08', fr: 'Comment allez-vous ?', en: 'How are you?', phonetic: 'haʊ ɑːr juː', category: 'Salutations' },
  { id: 'w-sal-09', fr: 'Très bien', en: 'Very well', phonetic: 'ˈvɛri wɛl', category: 'Salutations' },
  { id: 'w-sal-10', fr: 'Enchanté', en: 'Nice to meet you', phonetic: 'naɪs tə miːt juː', category: 'Salutations' },
  { id: 'w-sal-11', fr: 'Bonsoir', en: 'Good evening', phonetic: 'ɡʊd ˈiːvnɪŋ', category: 'Salutations' },
  { id: 'w-sal-12', fr: 'Bonne nuit', en: 'Good night', phonetic: 'ɡʊd naɪt', category: 'Salutations' },
  { id: 'w-sal-13', fr: 'Bienvenue', en: 'Welcome', phonetic: 'ˈwɛlkəm', category: 'Salutations' },
  { id: 'w-sal-14', fr: 'À bientôt', en: 'See you soon', phonetic: 'siː juː suːn', category: 'Salutations' },
  { id: 'w-sal-15', fr: 'Bonne journée', en: 'Have a nice day', phonetic: 'hæv ə naɪs deɪ', category: 'Salutations' },
  { id: 'w-sal-16', fr: 'Comment tu t\'appelles ?', en: 'What is your name?', phonetic: 'wɒt ɪz jɔːr neɪm', category: 'Salutations' },
  { id: 'w-sal-17', fr: 'Je m\'appelle…', en: 'My name is…', phonetic: 'maɪ neɪm ɪz', category: 'Salutations' },
  { id: 'w-sal-18', fr: 'Pardon', en: 'Sorry', phonetic: 'ˈsɒri', category: 'Salutations' },
  { id: 'w-sal-19', fr: 'De rien', en: "You're welcome", phonetic: 'jɔːr ˈwɛlkəm', category: 'Salutations' },
  { id: 'w-sal-20', fr: 'Félicitations', en: 'Congratulations', phonetic: 'kənˌɡrætʃʊˈleɪʃənz', category: 'Salutations' },

  // VOYAGE
  { id: 'w-voy-01', fr: 'Aéroport', en: 'Airport', phonetic: 'ˈɛrpɔːrt', category: 'Voyage' },
  { id: 'w-voy-02', fr: 'Hôtel', en: 'Hotel', phonetic: 'hoʊˈtɛl', category: 'Voyage' },
  { id: 'w-voy-03', fr: 'Passeport', en: 'Passport', phonetic: 'ˈpæspɔːrt', category: 'Voyage' },
  { id: 'w-voy-04', fr: 'Billet', en: 'Ticket', phonetic: 'ˈtɪkɪt', category: 'Voyage' },
  { id: 'w-voy-05', fr: 'Valise', en: 'Suitcase', phonetic: 'ˈsuːtkeɪs', category: 'Voyage' },
  { id: 'w-voy-06', fr: 'Douane', en: 'Customs', phonetic: 'ˈkʌstəmz', category: 'Voyage' },
  { id: 'w-voy-07', fr: 'Vol', en: 'Flight', phonetic: 'flaɪt', category: 'Voyage' },
  { id: 'w-voy-08', fr: 'Arrivée', en: 'Arrival', phonetic: 'əˈraɪvəl', category: 'Voyage' },
  { id: 'w-voy-09', fr: 'Départ', en: 'Departure', phonetic: 'dɪˈpɑːrtʃər', category: 'Voyage' },
  { id: 'w-voy-10', fr: 'Réservation', en: 'Reservation', phonetic: 'ˌrɛzərˈveɪʃən', category: 'Voyage' },
  { id: 'w-voy-11', fr: 'Chambre', en: 'Room', phonetic: 'ruːm', category: 'Voyage' },
  { id: 'w-voy-12', fr: 'Carte', en: 'Map', phonetic: 'mæp', category: 'Voyage' },
  { id: 'w-voy-13', fr: 'Ambassade', en: 'Embassy', phonetic: 'ˈɛmbəsi', category: 'Voyage' },
  { id: 'w-voy-14', fr: 'Visa', en: 'Visa', phonetic: 'ˈviːzə', category: 'Voyage' },
  { id: 'w-voy-15', fr: 'Escale', en: 'Layover', phonetic: 'ˈleɪoʊvər', category: 'Voyage' },
  { id: 'w-voy-16', fr: 'Enregistrement', en: 'Check-in', phonetic: 'ˈtʃɛk ɪn', category: 'Voyage' },
  { id: 'w-voy-17', fr: 'Porte d\'embarquement', en: 'Boarding gate', phonetic: 'ˈbɔːrdɪŋ ɡeɪt', category: 'Voyage' },
  { id: 'w-voy-18', fr: 'Bagage à main', en: 'Hand luggage', phonetic: 'hænd ˈlʌɡɪdʒ', category: 'Voyage' },
  { id: 'w-voy-19', fr: 'Retard', en: 'Delay', phonetic: 'dɪˈleɪ', category: 'Voyage' },
  { id: 'w-voy-20', fr: 'Annulé', en: 'Cancelled', phonetic: 'ˈkænsəld', category: 'Voyage' },
  { id: 'w-voy-21', fr: 'Touriste', en: 'Tourist', phonetic: 'ˈtʊərɪst', category: 'Voyage' },
  { id: 'w-voy-22', fr: 'Guide touristique', en: 'Tour guide', phonetic: 'tʊər ɡaɪd', category: 'Voyage' },
  { id: 'w-voy-23', fr: 'Monnaie locale', en: 'Local currency', phonetic: 'ˈloʊkəl ˈkʌrənsi', category: 'Voyage' },
  { id: 'w-voy-24', fr: 'Auberge de jeunesse', en: 'Youth hostel', phonetic: 'juːθ ˈhɒstəl', category: 'Voyage' },

  // NOURRITURE
  { id: 'w-nour-01', fr: 'Pain', en: 'Bread', phonetic: 'brɛd', category: 'Nourriture' },
  { id: 'w-nour-02', fr: 'Eau', en: 'Water', phonetic: 'ˈwɔːtər', category: 'Nourriture' },
  { id: 'w-nour-03', fr: 'Café', en: 'Coffee', phonetic: 'ˈkɒfi', category: 'Nourriture' },
  { id: 'w-nour-04', fr: 'Vin', en: 'Wine', phonetic: 'waɪn', category: 'Nourriture' },
  { id: 'w-nour-05', fr: 'Viande', en: 'Meat', phonetic: 'miːt', category: 'Nourriture' },
  { id: 'w-nour-06', fr: 'Poisson', en: 'Fish', phonetic: 'fɪʃ', category: 'Nourriture' },
  { id: 'w-nour-07', fr: 'Légumes', en: 'Vegetables', phonetic: 'ˈvɛdʒtəbəlz', category: 'Nourriture' },
  { id: 'w-nour-08', fr: 'Fruits', en: 'Fruit', phonetic: 'fruːt', category: 'Nourriture' },
  { id: 'w-nour-09', fr: 'Fromage', en: 'Cheese', phonetic: 'tʃiːz', category: 'Nourriture' },
  { id: 'w-nour-10', fr: 'Addition', en: 'Bill', phonetic: 'bɪl', category: 'Nourriture' },
  { id: 'w-nour-11', fr: 'Menu', en: 'Menu', phonetic: 'ˈmɛnjuː', category: 'Nourriture' },
  { id: 'w-nour-12', fr: 'Dessert', en: 'Dessert', phonetic: 'dɪˈzɜːrt', category: 'Nourriture' },
  { id: 'w-nour-13', fr: 'Petit-déjeuner', en: 'Breakfast', phonetic: 'ˈbrɛkfəst', category: 'Nourriture' },
  { id: 'w-nour-14', fr: 'Déjeuner', en: 'Lunch', phonetic: 'lʌntʃ', category: 'Nourriture' },
  { id: 'w-nour-15', fr: 'Dîner', en: 'Dinner', phonetic: 'ˈdɪnər', category: 'Nourriture' },
  { id: 'w-nour-16', fr: 'Poulet', en: 'Chicken', phonetic: 'ˈtʃɪkɪn', category: 'Nourriture' },
  { id: 'w-nour-17', fr: 'Bœuf', en: 'Beef', phonetic: 'biːf', category: 'Nourriture' },
  { id: 'w-nour-18', fr: 'Porc', en: 'Pork', phonetic: 'pɔːrk', category: 'Nourriture' },
  { id: 'w-nour-19', fr: 'Riz', en: 'Rice', phonetic: 'raɪs', category: 'Nourriture' },
  { id: 'w-nour-20', fr: 'Pâtes', en: 'Pasta', phonetic: 'ˈpæstə', category: 'Nourriture' },
  { id: 'w-nour-21', fr: 'Soupe', en: 'Soup', phonetic: 'suːp', category: 'Nourriture' },
  { id: 'w-nour-22', fr: 'Salade', en: 'Salad', phonetic: 'ˈsæləd', category: 'Nourriture' },
  { id: 'w-nour-23', fr: 'Beurre', en: 'Butter', phonetic: 'ˈbʌtər', category: 'Nourriture' },
  { id: 'w-nour-24', fr: 'Lait', en: 'Milk', phonetic: 'mɪlk', category: 'Nourriture' },
  { id: 'w-nour-25', fr: 'Œuf', en: 'Egg', phonetic: 'ɛɡ', category: 'Nourriture' },
  { id: 'w-nour-26', fr: 'Sucre', en: 'Sugar', phonetic: 'ˈʃʊɡər', category: 'Nourriture' },
  { id: 'w-nour-27', fr: 'Sel', en: 'Salt', phonetic: 'sɔːlt', category: 'Nourriture' },
  { id: 'w-nour-28', fr: 'Poivre', en: 'Pepper', phonetic: 'ˈpɛpər', category: 'Nourriture' },
  { id: 'w-nour-29', fr: 'Huile', en: 'Oil', phonetic: 'ɔɪl', category: 'Nourriture' },
  { id: 'w-nour-30', fr: 'Jus d\'orange', en: 'Orange juice', phonetic: 'ˈɒrɪndʒ dʒuːs', category: 'Nourriture' },

  // URGENCES
  { id: 'w-urg-01', fr: 'Aide', en: 'Help', phonetic: 'hɛlp', category: 'Urgences' },
  { id: 'w-urg-02', fr: 'Médecin', en: 'Doctor', phonetic: 'ˈdɒktər', category: 'Urgences' },
  { id: 'w-urg-03', fr: 'Hôpital', en: 'Hospital', phonetic: 'ˈhɒspɪtəl', category: 'Urgences' },
  { id: 'w-urg-04', fr: 'Police', en: 'Police', phonetic: 'pəˈliːs', category: 'Urgences' },
  { id: 'w-urg-05', fr: 'Feu', en: 'Fire', phonetic: 'faɪər', category: 'Urgences' },
  { id: 'w-urg-06', fr: 'Ambulance', en: 'Ambulance', phonetic: 'ˈæmbjʊləns', category: 'Urgences' },
  { id: 'w-urg-07', fr: 'Urgence', en: 'Emergency', phonetic: 'ɪˈmɜːrdʒənsi', category: 'Urgences' },
  { id: 'w-urg-08', fr: 'Blessé', en: 'Injured', phonetic: 'ˈɪndʒərd', category: 'Urgences' },
  { id: 'w-urg-09', fr: 'Perdu', en: 'Lost', phonetic: 'lɒst', category: 'Urgences' },
  { id: 'w-urg-10', fr: 'Volé', en: 'Stolen', phonetic: 'ˈstoʊlən', category: 'Urgences' },
  { id: 'w-urg-11', fr: 'Douleur', en: 'Pain', phonetic: 'peɪn', category: 'Urgences' },
  { id: 'w-urg-12', fr: 'Allergie', en: 'Allergy', phonetic: 'ˈælərdʒi', category: 'Urgences' },
  { id: 'w-urg-13', fr: 'Accident', en: 'Accident', phonetic: 'ˈæksɪdənt', category: 'Urgences' },
  { id: 'w-urg-14', fr: 'Danger', en: 'Danger', phonetic: 'ˈdeɪndʒər', category: 'Urgences' },
  { id: 'w-urg-15', fr: 'Pompiers', en: 'Firefighters', phonetic: 'ˈfaɪərfaɪtərz', category: 'Urgences' },
  { id: 'w-urg-16', fr: 'Appeler', en: 'Call', phonetic: 'kɔːl', category: 'Urgences' },
  { id: 'w-urg-17', fr: 'Secours', en: 'Rescue', phonetic: 'ˈrɛskjuː', category: 'Urgences' },
  { id: 'w-urg-18', fr: 'Inconscient', en: 'Unconscious', phonetic: 'ʌnˈkɒnʃəs', category: 'Urgences' },

  // CHIFFRES
  { id: 'w-num-01', fr: 'Zéro', en: 'Zero', phonetic: 'ˈzɪroʊ', category: 'Chiffres' },
  { id: 'w-num-02', fr: 'Un', en: 'One', phonetic: 'wʌn', category: 'Chiffres' },
  { id: 'w-num-03', fr: 'Deux', en: 'Two', phonetic: 'tuː', category: 'Chiffres' },
  { id: 'w-num-04', fr: 'Trois', en: 'Three', phonetic: 'θriː', category: 'Chiffres' },
  { id: 'w-num-05', fr: 'Quatre', en: 'Four', phonetic: 'fɔːr', category: 'Chiffres' },
  { id: 'w-num-06', fr: 'Cinq', en: 'Five', phonetic: 'faɪv', category: 'Chiffres' },
  { id: 'w-num-07', fr: 'Six', en: 'Six', phonetic: 'sɪks', category: 'Chiffres' },
  { id: 'w-num-08', fr: 'Sept', en: 'Seven', phonetic: 'ˈsɛvən', category: 'Chiffres' },
  { id: 'w-num-09', fr: 'Huit', en: 'Eight', phonetic: 'eɪt', category: 'Chiffres' },
  { id: 'w-num-10', fr: 'Neuf', en: 'Nine', phonetic: 'naɪn', category: 'Chiffres' },
  { id: 'w-num-11', fr: 'Dix', en: 'Ten', phonetic: 'tɛn', category: 'Chiffres' },
  { id: 'w-num-12', fr: 'Onze', en: 'Eleven', phonetic: 'ɪˈlɛvən', category: 'Chiffres' },
  { id: 'w-num-13', fr: 'Douze', en: 'Twelve', phonetic: 'twɛlv', category: 'Chiffres' },
  { id: 'w-num-14', fr: 'Vingt', en: 'Twenty', phonetic: 'ˈtwɛnti', category: 'Chiffres' },
  { id: 'w-num-15', fr: 'Trente', en: 'Thirty', phonetic: 'ˈθɜːrti', category: 'Chiffres' },
  { id: 'w-num-16', fr: 'Cinquante', en: 'Fifty', phonetic: 'ˈfɪfti', category: 'Chiffres' },
  { id: 'w-num-17', fr: 'Cent', en: 'Hundred', phonetic: 'ˈhʌndrəd', category: 'Chiffres' },
  { id: 'w-num-18', fr: 'Mille', en: 'Thousand', phonetic: 'ˈθaʊzənd', category: 'Chiffres' },
  { id: 'w-num-19', fr: 'Million', en: 'Million', phonetic: 'ˈmɪljən', category: 'Chiffres' },
  { id: 'w-num-20', fr: 'Premier', en: 'First', phonetic: 'fɜːrst', category: 'Chiffres' },
  { id: 'w-num-21', fr: 'Deuxième', en: 'Second', phonetic: 'ˈsɛkənd', category: 'Chiffres' },
  { id: 'w-num-22', fr: 'Dernier', en: 'Last', phonetic: 'læst', category: 'Chiffres' },
  { id: 'w-num-23', fr: 'La moitié', en: 'Half', phonetic: 'hɑːf', category: 'Chiffres' },
  { id: 'w-num-24', fr: 'Double', en: 'Double', phonetic: 'ˈdʌbəl', category: 'Chiffres' },

  // TRAVAIL
  { id: 'w-trav-01', fr: 'Réunion', en: 'Meeting', phonetic: 'ˈmiːtɪŋ', category: 'Travail' },
  { id: 'w-trav-02', fr: 'Bureau', en: 'Office', phonetic: 'ˈɒfɪs', category: 'Travail' },
  { id: 'w-trav-03', fr: 'Collègue', en: 'Colleague', phonetic: 'ˈkɒliːɡ', category: 'Travail' },
  { id: 'w-trav-04', fr: 'Patron', en: 'Boss', phonetic: 'bɒs', category: 'Travail' },
  { id: 'w-trav-05', fr: 'Contrat', en: 'Contract', phonetic: 'ˈkɒntrækt', category: 'Travail' },
  { id: 'w-trav-06', fr: 'Salaire', en: 'Salary', phonetic: 'ˈsæləri', category: 'Travail' },
  { id: 'w-trav-07', fr: 'Entretien', en: 'Interview', phonetic: 'ˈɪntərvjuː', category: 'Travail' },
  { id: 'w-trav-08', fr: 'Projet', en: 'Project', phonetic: 'ˈprɒdʒɛkt', category: 'Travail' },
  { id: 'w-trav-09', fr: 'Délai', en: 'Deadline', phonetic: 'ˈdɛdlaɪn', category: 'Travail' },
  { id: 'w-trav-10', fr: 'Rapport', en: 'Report', phonetic: 'rɪˈpɔːrt', category: 'Travail' },
  { id: 'w-trav-11', fr: 'Client', en: 'Client', phonetic: 'ˈklaɪənt', category: 'Travail' },
  { id: 'w-trav-12', fr: 'Présentation', en: 'Presentation', phonetic: 'ˌprɛzənˈteɪʃən', category: 'Travail' },
  { id: 'w-trav-13', fr: 'Télétravail', en: 'Remote work', phonetic: 'rɪˈmoʊt wɜːrk', category: 'Travail' },
  { id: 'w-trav-14', fr: 'Promotion', en: 'Promotion', phonetic: 'prəˈmoʊʃən', category: 'Travail' },
  { id: 'w-trav-15', fr: 'Congé', en: 'Leave', phonetic: 'liːv', category: 'Travail' },
  { id: 'w-trav-16', fr: 'Candidature', en: 'Application', phonetic: 'ˌæplɪˈkeɪʃən', category: 'Travail' },
  { id: 'w-trav-17', fr: 'CV', en: 'Resume / CV', phonetic: 'ˈrɛzjʊmeɪ', category: 'Travail' },
  { id: 'w-trav-18', fr: 'Réseautage', en: 'Networking', phonetic: 'ˈnɛtwɜːrkɪŋ', category: 'Travail' },
  { id: 'w-trav-19', fr: 'Objectif', en: 'Goal', phonetic: 'ɡoʊl', category: 'Travail' },
  { id: 'w-trav-20', fr: 'Stratégie', en: 'Strategy', phonetic: 'ˈstrætɪdʒi', category: 'Travail' },
  { id: 'w-trav-21', fr: 'Employé', en: 'Employee', phonetic: 'ɪmˈplɔɪiː', category: 'Travail' },
  { id: 'w-trav-22', fr: 'Employeur', en: 'Employer', phonetic: 'ɪmˈplɔɪər', category: 'Travail' },
  { id: 'w-trav-23', fr: 'Entreprise', en: 'Company', phonetic: 'ˈkʌmpəni', category: 'Travail' },
  { id: 'w-trav-24', fr: 'Récompense', en: 'Bonus', phonetic: 'ˈboʊnəs', category: 'Travail' },

  // FAMILLE
  { id: 'w-fam-01', fr: 'Père', en: 'Father', phonetic: 'ˈfɑːðər', category: 'Famille' },
  { id: 'w-fam-02', fr: 'Mère', en: 'Mother', phonetic: 'ˈmʌðər', category: 'Famille' },
  { id: 'w-fam-03', fr: 'Frère', en: 'Brother', phonetic: 'ˈbrʌðər', category: 'Famille' },
  { id: 'w-fam-04', fr: 'Sœur', en: 'Sister', phonetic: 'ˈsɪstər', category: 'Famille' },
  { id: 'w-fam-05', fr: 'Enfant', en: 'Child', phonetic: 'tʃaɪld', category: 'Famille' },
  { id: 'w-fam-06', fr: 'Mari', en: 'Husband', phonetic: 'ˈhʌzbənd', category: 'Famille' },
  { id: 'w-fam-07', fr: 'Femme', en: 'Wife', phonetic: 'waɪf', category: 'Famille' },
  { id: 'w-fam-08', fr: 'Grand-père', en: 'Grandfather', phonetic: 'ˈɡrænfɑːðər', category: 'Famille' },
  { id: 'w-fam-09', fr: 'Grand-mère', en: 'Grandmother', phonetic: 'ˈɡrænmʌðər', category: 'Famille' },
  { id: 'w-fam-10', fr: 'Ami', en: 'Friend', phonetic: 'frɛnd', category: 'Famille' },
  { id: 'w-fam-11', fr: 'Bébé', en: 'Baby', phonetic: 'ˈbeɪbi', category: 'Famille' },
  { id: 'w-fam-12', fr: 'Cousin', en: 'Cousin', phonetic: 'ˈkʌzən', category: 'Famille' },
  { id: 'w-fam-13', fr: 'Oncle', en: 'Uncle', phonetic: 'ˈʌŋkəl', category: 'Famille' },
  { id: 'w-fam-14', fr: 'Tante', en: 'Aunt', phonetic: 'ɑːnt', category: 'Famille' },
  { id: 'w-fam-15', fr: 'Neveu', en: 'Nephew', phonetic: 'ˈnɛfjuː', category: 'Famille' },
  { id: 'w-fam-16', fr: 'Nièce', en: 'Niece', phonetic: 'niːs', category: 'Famille' },
  { id: 'w-fam-17', fr: 'Fils', en: 'Son', phonetic: 'sʌn', category: 'Famille' },
  { id: 'w-fam-18', fr: 'Fille', en: 'Daughter', phonetic: 'ˈdɔːtər', category: 'Famille' },
  { id: 'w-fam-19', fr: 'Petit-fils', en: 'Grandson', phonetic: 'ˈɡrænsʌn', category: 'Famille' },
  { id: 'w-fam-20', fr: 'Petite-fille', en: 'Granddaughter', phonetic: 'ˈɡrændɔːtər', category: 'Famille' },

  // TEMPS
  { id: 'w-tem-01', fr: "Aujourd'hui", en: 'Today', phonetic: 'təˈdeɪ', category: 'Temps' },
  { id: 'w-tem-02', fr: 'Demain', en: 'Tomorrow', phonetic: 'təˈmɒroʊ', category: 'Temps' },
  { id: 'w-tem-03', fr: 'Hier', en: 'Yesterday', phonetic: 'ˈjɛstərdeɪ', category: 'Temps' },
  { id: 'w-tem-04', fr: 'Matin', en: 'Morning', phonetic: 'ˈmɔːrnɪŋ', category: 'Temps' },
  { id: 'w-tem-05', fr: 'Soir', en: 'Evening', phonetic: 'ˈiːvnɪŋ', category: 'Temps' },
  { id: 'w-tem-06', fr: 'Semaine', en: 'Week', phonetic: 'wiːk', category: 'Temps' },
  { id: 'w-tem-07', fr: 'Mois', en: 'Month', phonetic: 'mʌnθ', category: 'Temps' },
  { id: 'w-tem-08', fr: 'Année', en: 'Year', phonetic: 'jɪər', category: 'Temps' },
  { id: 'w-tem-09', fr: 'Maintenant', en: 'Now', phonetic: 'naʊ', category: 'Temps' },
  { id: 'w-tem-10', fr: 'Bientôt', en: 'Soon', phonetic: 'suːn', category: 'Temps' },
  { id: 'w-tem-11', fr: 'Toujours', en: 'Always', phonetic: 'ˈɔːlweɪz', category: 'Temps' },
  { id: 'w-tem-12', fr: 'Jamais', en: 'Never', phonetic: 'ˈnɛvər', category: 'Temps' },
  { id: 'w-tem-13', fr: 'Après-midi', en: 'Afternoon', phonetic: 'ˌɑːftərˈnuːn', category: 'Temps' },
  { id: 'w-tem-14', fr: 'Nuit', en: 'Night', phonetic: 'naɪt', category: 'Temps' },
  { id: 'w-tem-15', fr: 'Lundi', en: 'Monday', phonetic: 'ˈmʌndeɪ', category: 'Temps' },
  { id: 'w-tem-16', fr: 'Mardi', en: 'Tuesday', phonetic: 'ˈtjuːzdeɪ', category: 'Temps' },
  { id: 'w-tem-17', fr: 'Mercredi', en: 'Wednesday', phonetic: 'ˈwɛnzdeɪ', category: 'Temps' },
  { id: 'w-tem-18', fr: 'Jeudi', en: 'Thursday', phonetic: 'ˈθɜːrzdeɪ', category: 'Temps' },
  { id: 'w-tem-19', fr: 'Vendredi', en: 'Friday', phonetic: 'ˈfraɪdeɪ', category: 'Temps' },
  { id: 'w-tem-20', fr: 'Samedi', en: 'Saturday', phonetic: 'ˈsætərdeɪ', category: 'Temps' },
  { id: 'w-tem-21', fr: 'Dimanche', en: 'Sunday', phonetic: 'ˈsʌndeɪ', category: 'Temps' },
  { id: 'w-tem-22', fr: 'Janvier', en: 'January', phonetic: 'ˈdʒænjʊəri', category: 'Temps' },
  { id: 'w-tem-23', fr: 'Février', en: 'February', phonetic: 'ˈfɛbrʊəri', category: 'Temps' },
  { id: 'w-tem-24', fr: 'Mars', en: 'March', phonetic: 'mɑːrtʃ', category: 'Temps' },
  { id: 'w-tem-25', fr: 'Avril', en: 'April', phonetic: 'ˈeɪprəl', category: 'Temps' },
  { id: 'w-tem-26', fr: 'Mai', en: 'May', phonetic: 'meɪ', category: 'Temps' },
  { id: 'w-tem-27', fr: 'Juin', en: 'June', phonetic: 'dʒuːn', category: 'Temps' },
  { id: 'w-tem-28', fr: 'Juillet', en: 'July', phonetic: 'dʒʊˈlaɪ', category: 'Temps' },
  { id: 'w-tem-29', fr: 'Août', en: 'August', phonetic: 'ˈɔːɡəst', category: 'Temps' },
  { id: 'w-tem-30', fr: 'Septembre', en: 'September', phonetic: 'sɛpˈtɛmbər', category: 'Temps' },
  { id: 'w-tem-31', fr: 'Octobre', en: 'October', phonetic: 'ɒkˈtoʊbər', category: 'Temps' },
  { id: 'w-tem-32', fr: 'Novembre', en: 'November', phonetic: 'noʊˈvɛmbər', category: 'Temps' },
  { id: 'w-tem-33', fr: 'Décembre', en: 'December', phonetic: 'dɪˈsɛmbər', category: 'Temps' },

  // SHOPPING
  { id: 'w-shop-01', fr: 'Magasin', en: 'Store', phonetic: 'stɔːr', category: 'Shopping' },
  { id: 'w-shop-02', fr: 'Prix', en: 'Price', phonetic: 'praɪs', category: 'Shopping' },
  { id: 'w-shop-03', fr: 'Réduction', en: 'Discount', phonetic: 'ˈdɪskaʊnt', category: 'Shopping' },
  { id: 'w-shop-04', fr: 'Caisse', en: 'Checkout', phonetic: 'ˈtʃɛkaʊt', category: 'Shopping' },
  { id: 'w-shop-05', fr: 'Carte bancaire', en: 'Credit card', phonetic: 'ˈkrɛdɪt kɑːrd', category: 'Shopping' },
  { id: 'w-shop-06', fr: 'Reçu', en: 'Receipt', phonetic: 'rɪˈsiːt', category: 'Shopping' },
  { id: 'w-shop-07', fr: 'Taille', en: 'Size', phonetic: 'saɪz', category: 'Shopping' },
  { id: 'w-shop-08', fr: 'Couleur', en: 'Colour', phonetic: 'ˈkʌlər', category: 'Shopping' },
  { id: 'w-shop-09', fr: 'Échange', en: 'Exchange', phonetic: 'ɪksˈtʃeɪndʒ', category: 'Shopping' },
  { id: 'w-shop-10', fr: 'Remboursement', en: 'Refund', phonetic: 'ˈriːfʌnd', category: 'Shopping' },
  { id: 'w-shop-11', fr: 'Soldes', en: 'Sales', phonetic: 'seɪlz', category: 'Shopping' },
  { id: 'w-shop-12', fr: 'Panier', en: 'Basket', phonetic: 'ˈbɑːskɪt', category: 'Shopping' },
  { id: 'w-shop-13', fr: 'Livraison', en: 'Delivery', phonetic: 'dɪˈlɪvəri', category: 'Shopping' },
  { id: 'w-shop-14', fr: 'Commande', en: 'Order', phonetic: 'ˈɔːrdər', category: 'Shopping' },
  { id: 'w-shop-15', fr: 'Gratuit', en: 'Free', phonetic: 'friː', category: 'Shopping' },
  { id: 'w-shop-16', fr: 'Cher', en: 'Expensive', phonetic: 'ɪkˈspɛnsɪv', category: 'Shopping' },
  { id: 'w-shop-17', fr: 'Bon marché', en: 'Cheap', phonetic: 'tʃiːp', category: 'Shopping' },
  { id: 'w-shop-18', fr: 'Marque', en: 'Brand', phonetic: 'brænd', category: 'Shopping' },

  // SANTÉ
  { id: 'w-san-01', fr: 'Pharmacie', en: 'Pharmacy', phonetic: 'ˈfɑːrməsi', category: 'Santé' },
  { id: 'w-san-02', fr: 'Médicament', en: 'Medicine', phonetic: 'ˈmɛdsɪn', category: 'Santé' },
  { id: 'w-san-03', fr: 'Ordonnance', en: 'Prescription', phonetic: 'prɪˈskrɪpʃən', category: 'Santé' },
  { id: 'w-san-04', fr: 'Fièvre', en: 'Fever', phonetic: 'ˈfiːvər', category: 'Santé' },
  { id: 'w-san-05', fr: 'Toux', en: 'Cough', phonetic: 'kɒf', category: 'Santé' },
  { id: 'w-san-06', fr: 'Mal de tête', en: 'Headache', phonetic: 'ˈhɛdeɪk', category: 'Santé' },
  { id: 'w-san-07', fr: 'Rendez-vous', en: 'Appointment', phonetic: 'əˈpɔɪntmənt', category: 'Santé' },
  { id: 'w-san-08', fr: 'Assurance', en: 'Insurance', phonetic: 'ɪnˈʃʊərəns', category: 'Santé' },
  { id: 'w-san-09', fr: 'Opération', en: 'Surgery', phonetic: 'ˈsɜːrdʒəri', category: 'Santé' },
  { id: 'w-san-10', fr: 'Infirmière', en: 'Nurse', phonetic: 'nɜːrs', category: 'Santé' },
  { id: 'w-san-11', fr: 'Dentiste', en: 'Dentist', phonetic: 'ˈdɛntɪst', category: 'Santé' },
  { id: 'w-san-12', fr: 'Rhume', en: 'Cold', phonetic: 'koʊld', category: 'Santé' },
  { id: 'w-san-13', fr: 'Grippe', en: 'Flu', phonetic: 'fluː', category: 'Santé' },
  { id: 'w-san-14', fr: 'Tension artérielle', en: 'Blood pressure', phonetic: 'blʌd ˈprɛʃər', category: 'Santé' },
  { id: 'w-san-15', fr: 'Vaccin', en: 'Vaccine', phonetic: 'ˈvæksiːn', category: 'Santé' },
  { id: 'w-san-16', fr: 'Blessure', en: 'Wound', phonetic: 'wuːnd', category: 'Santé' },
  { id: 'w-san-17', fr: 'Fracture', en: 'Fracture', phonetic: 'ˈfræktʃər', category: 'Santé' },
  { id: 'w-san-18', fr: 'Radiographie', en: 'X-ray', phonetic: 'ˈɛks reɪ', category: 'Santé' },

  // TRANSPORTS
  { id: 'w-trans-01', fr: 'Voiture', en: 'Car', phonetic: 'kɑːr', category: 'Transports' },
  { id: 'w-trans-02', fr: 'Train', en: 'Train', phonetic: 'treɪn', category: 'Transports' },
  { id: 'w-trans-03', fr: 'Bus', en: 'Bus', phonetic: 'bʌs', category: 'Transports' },
  { id: 'w-trans-04', fr: 'Taxi', en: 'Taxi', phonetic: 'ˈtæksi', category: 'Transports' },
  { id: 'w-trans-05', fr: 'Métro', en: 'Subway', phonetic: 'ˈsʌbweɪ', category: 'Transports' },
  { id: 'w-trans-06', fr: 'Vélo', en: 'Bicycle', phonetic: 'ˈbaɪsɪkəl', category: 'Transports' },
  { id: 'w-trans-07', fr: 'Gare', en: 'Station', phonetic: 'ˈsteɪʃən', category: 'Transports' },
  { id: 'w-trans-08', fr: 'Arrêt', en: 'Stop', phonetic: 'stɒp', category: 'Transports' },
  { id: 'w-trans-09', fr: 'Itinéraire', en: 'Route', phonetic: 'ruːt', category: 'Transports' },
  { id: 'w-trans-10', fr: 'Embouteillage', en: 'Traffic jam', phonetic: 'ˈtræfɪk dʒæm', category: 'Transports' },
  { id: 'w-trans-11', fr: 'Avion', en: 'Plane', phonetic: 'pleɪn', category: 'Transports' },
  { id: 'w-trans-12', fr: 'Bateau', en: 'Boat', phonetic: 'boʊt', category: 'Transports' },
  { id: 'w-trans-13', fr: 'Moto', en: 'Motorbike', phonetic: 'ˈmoʊtərbaɪk', category: 'Transports' },
  { id: 'w-trans-14', fr: 'Camion', en: 'Truck', phonetic: 'trʌk', category: 'Transports' },
  { id: 'w-trans-15', fr: 'Parking', en: 'Car park', phonetic: 'kɑːr pɑːrk', category: 'Transports' },
  { id: 'w-trans-16', fr: 'Essence', en: 'Petrol', phonetic: 'ˈpɛtrəl', category: 'Transports' },
  { id: 'w-trans-17', fr: 'Permis de conduire', en: "Driver's licence", phonetic: 'ˈdraɪvərz ˈlaɪsəns', category: 'Transports' },
  { id: 'w-trans-18', fr: 'Rond-point', en: 'Roundabout', phonetic: 'ˈraʊndəbaʊt', category: 'Transports' },

  // COULEURS
  { id: 'w-col-01', fr: 'Rouge', en: 'Red', phonetic: 'rɛd', category: 'Couleurs' },
  { id: 'w-col-02', fr: 'Bleu', en: 'Blue', phonetic: 'bluː', category: 'Couleurs' },
  { id: 'w-col-03', fr: 'Vert', en: 'Green', phonetic: 'ɡriːn', category: 'Couleurs' },
  { id: 'w-col-04', fr: 'Jaune', en: 'Yellow', phonetic: 'ˈjɛloʊ', category: 'Couleurs' },
  { id: 'w-col-05', fr: 'Noir', en: 'Black', phonetic: 'blæk', category: 'Couleurs' },
  { id: 'w-col-06', fr: 'Blanc', en: 'White', phonetic: 'waɪt', category: 'Couleurs' },
  { id: 'w-col-07', fr: 'Gris', en: 'Grey', phonetic: 'ɡreɪ', category: 'Couleurs' },
  { id: 'w-col-08', fr: 'Orange', en: 'Orange', phonetic: 'ˈɒrɪndʒ', category: 'Couleurs' },
  { id: 'w-col-09', fr: 'Rose', en: 'Pink', phonetic: 'pɪŋk', category: 'Couleurs' },
  { id: 'w-col-10', fr: 'Violet', en: 'Purple', phonetic: 'ˈpɜːrpəl', category: 'Couleurs' },
  { id: 'w-col-11', fr: 'Marron', en: 'Brown', phonetic: 'braʊn', category: 'Couleurs' },
  { id: 'w-col-12', fr: 'Beige', en: 'Beige', phonetic: 'beɪʒ', category: 'Couleurs' },
  { id: 'w-col-13', fr: 'Doré', en: 'Golden', phonetic: 'ˈɡoʊldən', category: 'Couleurs' },
  { id: 'w-col-14', fr: 'Argenté', en: 'Silver', phonetic: 'ˈsɪlvər', category: 'Couleurs' },
  { id: 'w-col-15', fr: 'Turquoise', en: 'Turquoise', phonetic: 'ˈtɜːrkwɔɪz', category: 'Couleurs' },

  // CORPS HUMAIN
  { id: 'w-corps-01', fr: 'Tête', en: 'Head', phonetic: 'hɛd', category: 'Corps humain' },
  { id: 'w-corps-02', fr: 'Visage', en: 'Face', phonetic: 'feɪs', category: 'Corps humain' },
  { id: 'w-corps-03', fr: 'Yeux', en: 'Eyes', phonetic: 'aɪz', category: 'Corps humain' },
  { id: 'w-corps-04', fr: 'Nez', en: 'Nose', phonetic: 'noʊz', category: 'Corps humain' },
  { id: 'w-corps-05', fr: 'Bouche', en: 'Mouth', phonetic: 'maʊθ', category: 'Corps humain' },
  { id: 'w-corps-06', fr: 'Oreille', en: 'Ear', phonetic: 'ɪər', category: 'Corps humain' },
  { id: 'w-corps-07', fr: 'Cou', en: 'Neck', phonetic: 'nɛk', category: 'Corps humain' },
  { id: 'w-corps-08', fr: 'Épaule', en: 'Shoulder', phonetic: 'ˈʃoʊldər', category: 'Corps humain' },
  { id: 'w-corps-09', fr: 'Bras', en: 'Arm', phonetic: 'ɑːrm', category: 'Corps humain' },
  { id: 'w-corps-10', fr: 'Main', en: 'Hand', phonetic: 'hænd', category: 'Corps humain' },
  { id: 'w-corps-11', fr: 'Doigt', en: 'Finger', phonetic: 'ˈfɪŋɡər', category: 'Corps humain' },
  { id: 'w-corps-12', fr: 'Dos', en: 'Back', phonetic: 'bæk', category: 'Corps humain' },
  { id: 'w-corps-13', fr: 'Ventre', en: 'Stomach', phonetic: 'ˈstʌmək', category: 'Corps humain' },
  { id: 'w-corps-14', fr: 'Jambe', en: 'Leg', phonetic: 'lɛɡ', category: 'Corps humain' },
  { id: 'w-corps-15', fr: 'Genou', en: 'Knee', phonetic: 'niː', category: 'Corps humain' },
  { id: 'w-corps-16', fr: 'Pied', en: 'Foot', phonetic: 'fʊt', category: 'Corps humain' },
  { id: 'w-corps-17', fr: 'Cœur', en: 'Heart', phonetic: 'hɑːrt', category: 'Corps humain' },
  { id: 'w-corps-18', fr: 'Poumon', en: 'Lung', phonetic: 'lʌŋ', category: 'Corps humain' },
  { id: 'w-corps-19', fr: 'Cheveux', en: 'Hair', phonetic: 'hɛər', category: 'Corps humain' },
  { id: 'w-corps-20', fr: 'Dent', en: 'Tooth', phonetic: 'tuːθ', category: 'Corps humain' },

  // MAISON
  { id: 'w-mais-01', fr: 'Maison', en: 'House', phonetic: 'haʊs', category: 'Maison' },
  { id: 'w-mais-02', fr: 'Appartement', en: 'Flat / Apartment', phonetic: 'flæt', category: 'Maison' },
  { id: 'w-mais-03', fr: 'Cuisine', en: 'Kitchen', phonetic: 'ˈkɪtʃɪn', category: 'Maison' },
  { id: 'w-mais-04', fr: 'Salon', en: 'Living room', phonetic: 'ˈlɪvɪŋ ruːm', category: 'Maison' },
  { id: 'w-mais-05', fr: 'Chambre à coucher', en: 'Bedroom', phonetic: 'ˈbɛdruːm', category: 'Maison' },
  { id: 'w-mais-06', fr: 'Salle de bain', en: 'Bathroom', phonetic: 'ˈbɑːθruːm', category: 'Maison' },
  { id: 'w-mais-07', fr: 'Jardin', en: 'Garden', phonetic: 'ˈɡɑːrdən', category: 'Maison' },
  { id: 'w-mais-08', fr: 'Porte', en: 'Door', phonetic: 'dɔːr', category: 'Maison' },
  { id: 'w-mais-09', fr: 'Fenêtre', en: 'Window', phonetic: 'ˈwɪndoʊ', category: 'Maison' },
  { id: 'w-mais-10', fr: 'Escalier', en: 'Stairs', phonetic: 'stɛərz', category: 'Maison' },
  { id: 'w-mais-11', fr: 'Canapé', en: 'Sofa', phonetic: 'ˈsoʊfə', category: 'Maison' },
  { id: 'w-mais-12', fr: 'Table', en: 'Table', phonetic: 'ˈteɪbəl', category: 'Maison' },
  { id: 'w-mais-13', fr: 'Chaise', en: 'Chair', phonetic: 'tʃɛər', category: 'Maison' },
  { id: 'w-mais-14', fr: 'Lit', en: 'Bed', phonetic: 'bɛd', category: 'Maison' },
  { id: 'w-mais-15', fr: 'Réfrigérateur', en: 'Fridge', phonetic: 'frɪdʒ', category: 'Maison' },
  { id: 'w-mais-16', fr: 'Lave-vaisselle', en: 'Dishwasher', phonetic: 'ˈdɪʃwɒʃər', category: 'Maison' },
  { id: 'w-mais-17', fr: 'Loyer', en: 'Rent', phonetic: 'rɛnt', category: 'Maison' },
  { id: 'w-mais-18', fr: 'Voisin', en: 'Neighbour', phonetic: 'ˈneɪbər', category: 'Maison' },

  // NATURE
  { id: 'w-nat-01', fr: 'Soleil', en: 'Sun', phonetic: 'sʌn', category: 'Nature' },
  { id: 'w-nat-02', fr: 'Lune', en: 'Moon', phonetic: 'muːn', category: 'Nature' },
  { id: 'w-nat-03', fr: 'Étoile', en: 'Star', phonetic: 'stɑːr', category: 'Nature' },
  { id: 'w-nat-04', fr: 'Mer', en: 'Sea', phonetic: 'siː', category: 'Nature' },
  { id: 'w-nat-05', fr: 'Rivière', en: 'River', phonetic: 'ˈrɪvər', category: 'Nature' },
  { id: 'w-nat-06', fr: 'Montagne', en: 'Mountain', phonetic: 'ˈmaʊntɪn', category: 'Nature' },
  { id: 'w-nat-07', fr: 'Forêt', en: 'Forest', phonetic: 'ˈfɒrɪst', category: 'Nature' },
  { id: 'w-nat-08', fr: 'Plage', en: 'Beach', phonetic: 'biːtʃ', category: 'Nature' },
  { id: 'w-nat-09', fr: 'Pluie', en: 'Rain', phonetic: 'reɪn', category: 'Nature' },
  { id: 'w-nat-10', fr: 'Neige', en: 'Snow', phonetic: 'snoʊ', category: 'Nature' },
  { id: 'w-nat-11', fr: 'Vent', en: 'Wind', phonetic: 'wɪnd', category: 'Nature' },
  { id: 'w-nat-12', fr: 'Nuage', en: 'Cloud', phonetic: 'klaʊd', category: 'Nature' },
  { id: 'w-nat-13', fr: 'Fleur', en: 'Flower', phonetic: 'ˈflaʊər', category: 'Nature' },
  { id: 'w-nat-14', fr: 'Arbre', en: 'Tree', phonetic: 'triː', category: 'Nature' },
  { id: 'w-nat-15', fr: 'Animal', en: 'Animal', phonetic: 'ˈænɪməl', category: 'Nature' },
  { id: 'w-nat-16', fr: 'Chien', en: 'Dog', phonetic: 'dɒɡ', category: 'Nature' },
  { id: 'w-nat-17', fr: 'Chat', en: 'Cat', phonetic: 'kæt', category: 'Nature' },
  { id: 'w-nat-18', fr: 'Oiseau', en: 'Bird', phonetic: 'bɜːrd', category: 'Nature' },
  { id: 'w-nat-19', fr: 'Lac', en: 'Lake', phonetic: 'leɪk', category: 'Nature' },
  { id: 'w-nat-20', fr: 'Île', en: 'Island', phonetic: 'ˈaɪlənd', category: 'Nature' },

  // VÊTEMENTS
  { id: 'w-vet-01', fr: 'Chemise', en: 'Shirt', phonetic: 'ʃɜːrt', category: 'Vêtements' },
  { id: 'w-vet-02', fr: 'Pantalon', en: 'Trousers', phonetic: 'ˈtraʊzərz', category: 'Vêtements' },
  { id: 'w-vet-03', fr: 'Robe', en: 'Dress', phonetic: 'drɛs', category: 'Vêtements' },
  { id: 'w-vet-04', fr: 'Veste', en: 'Jacket', phonetic: 'ˈdʒækɪt', category: 'Vêtements' },
  { id: 'w-vet-05', fr: 'Manteau', en: 'Coat', phonetic: 'koʊt', category: 'Vêtements' },
  { id: 'w-vet-06', fr: 'Chaussures', en: 'Shoes', phonetic: 'ʃuːz', category: 'Vêtements' },
  { id: 'w-vet-07', fr: 'Chaussettes', en: 'Socks', phonetic: 'sɒks', category: 'Vêtements' },
  { id: 'w-vet-08', fr: 'Pull', en: 'Jumper / Sweater', phonetic: 'ˈdʒʌmpər', category: 'Vêtements' },
  { id: 'w-vet-09', fr: 'Jean', en: 'Jeans', phonetic: 'dʒiːnz', category: 'Vêtements' },
  { id: 'w-vet-10', fr: 'T-shirt', en: 'T-shirt', phonetic: 'ˈtiːʃɜːrt', category: 'Vêtements' },
  { id: 'w-vet-11', fr: 'Chapeau', en: 'Hat', phonetic: 'hæt', category: 'Vêtements' },
  { id: 'w-vet-12', fr: 'Écharpe', en: 'Scarf', phonetic: 'skɑːrf', category: 'Vêtements' },
  { id: 'w-vet-13', fr: 'Gants', en: 'Gloves', phonetic: 'ɡlʌvz', category: 'Vêtements' },
  { id: 'w-vet-14', fr: 'Ceinture', en: 'Belt', phonetic: 'bɛlt', category: 'Vêtements' },
  { id: 'w-vet-15', fr: 'Lunettes', en: 'Glasses', phonetic: 'ˈɡlɑːsɪz', category: 'Vêtements' },

  // ADJECTIFS
  { id: 'w-adj-01', fr: 'Grand', en: 'Big / Tall', phonetic: 'bɪɡ', category: 'Adjectifs' },
  { id: 'w-adj-02', fr: 'Petit', en: 'Small / Short', phonetic: 'smɔːl', category: 'Adjectifs' },
  { id: 'w-adj-03', fr: 'Beau / Belle', en: 'Beautiful', phonetic: 'ˈbjuːtɪfəl', category: 'Adjectifs' },
  { id: 'w-adj-04', fr: 'Laid', en: 'Ugly', phonetic: 'ˈʌɡli', category: 'Adjectifs' },
  { id: 'w-adj-05', fr: 'Rapide', en: 'Fast', phonetic: 'fɑːst', category: 'Adjectifs' },
  { id: 'w-adj-06', fr: 'Lent', en: 'Slow', phonetic: 'sloʊ', category: 'Adjectifs' },
  { id: 'w-adj-07', fr: 'Chaud', en: 'Hot', phonetic: 'hɒt', category: 'Adjectifs' },
  { id: 'w-adj-08', fr: 'Froid', en: 'Cold', phonetic: 'koʊld', category: 'Adjectifs' },
  { id: 'w-adj-09', fr: 'Nouveau', en: 'New', phonetic: 'njuː', category: 'Adjectifs' },
  { id: 'w-adj-10', fr: 'Vieux', en: 'Old', phonetic: 'oʊld', category: 'Adjectifs' },
  { id: 'w-adj-11', fr: 'Facile', en: 'Easy', phonetic: 'ˈiːzi', category: 'Adjectifs' },
  { id: 'w-adj-12', fr: 'Difficile', en: 'Difficult', phonetic: 'ˈdɪfɪkəlt', category: 'Adjectifs' },
  { id: 'w-adj-13', fr: 'Heureux', en: 'Happy', phonetic: 'ˈhæpi', category: 'Adjectifs' },
  { id: 'w-adj-14', fr: 'Triste', en: 'Sad', phonetic: 'sæd', category: 'Adjectifs' },
  { id: 'w-adj-15', fr: 'Fatigué', en: 'Tired', phonetic: 'ˈtaɪərd', category: 'Adjectifs' },
  { id: 'w-adj-16', fr: 'Occupé', en: 'Busy', phonetic: 'ˈbɪzi', category: 'Adjectifs' },
  { id: 'w-adj-17', fr: 'Libre', en: 'Free', phonetic: 'friː', category: 'Adjectifs' },
  { id: 'w-adj-18', fr: 'Intéressant', en: 'Interesting', phonetic: 'ˈɪntrəstɪŋ', category: 'Adjectifs' },
  { id: 'w-adj-19', fr: 'Ennuyeux', en: 'Boring', phonetic: 'ˈbɔːrɪŋ', category: 'Adjectifs' },
  { id: 'w-adj-20', fr: 'Propre', en: 'Clean', phonetic: 'kliːn', category: 'Adjectifs' },

  // VERBES COURANTS
  { id: 'w-verb-01', fr: 'Aller', en: 'To go', phonetic: 'tuː ɡoʊ', category: 'Verbes courants' },
  { id: 'w-verb-02', fr: 'Venir', en: 'To come', phonetic: 'tuː kʌm', category: 'Verbes courants' },
  { id: 'w-verb-03', fr: 'Faire', en: 'To do / make', phonetic: 'tuː duː', category: 'Verbes courants' },
  { id: 'w-verb-04', fr: 'Dire', en: 'To say', phonetic: 'tuː seɪ', category: 'Verbes courants' },
  { id: 'w-verb-05', fr: 'Voir', en: 'To see', phonetic: 'tuː siː', category: 'Verbes courants' },
  { id: 'w-verb-06', fr: 'Savoir', en: 'To know', phonetic: 'tuː noʊ', category: 'Verbes courants' },
  { id: 'w-verb-07', fr: 'Vouloir', en: 'To want', phonetic: 'tuː wɒnt', category: 'Verbes courants' },
  { id: 'w-verb-08', fr: 'Pouvoir', en: 'To be able to', phonetic: 'tuː biː ˈeɪbəl tuː', category: 'Verbes courants' },
  { id: 'w-verb-09', fr: 'Devoir', en: 'To have to / must', phonetic: 'tuː hæv tuː', category: 'Verbes courants' },
  { id: 'w-verb-10', fr: 'Penser', en: 'To think', phonetic: 'tuː θɪŋk', category: 'Verbes courants' },
  { id: 'w-verb-11', fr: 'Parler', en: 'To speak', phonetic: 'tuː spiːk', category: 'Verbes courants' },
  { id: 'w-verb-12', fr: 'Écouter', en: 'To listen', phonetic: 'tuː ˈlɪsən', category: 'Verbes courants' },
  { id: 'w-verb-13', fr: 'Lire', en: 'To read', phonetic: 'tuː riːd', category: 'Verbes courants' },
  { id: 'w-verb-14', fr: 'Écrire', en: 'To write', phonetic: 'tuː raɪt', category: 'Verbes courants' },
  { id: 'w-verb-15', fr: 'Manger', en: 'To eat', phonetic: 'tuː iːt', category: 'Verbes courants' },
  { id: 'w-verb-16', fr: 'Boire', en: 'To drink', phonetic: 'tuː drɪŋk', category: 'Verbes courants' },
  { id: 'w-verb-17', fr: 'Dormir', en: 'To sleep', phonetic: 'tuː sliːp', category: 'Verbes courants' },
  { id: 'w-verb-18', fr: 'Travailler', en: 'To work', phonetic: 'tuː wɜːrk', category: 'Verbes courants' },
  { id: 'w-verb-19', fr: 'Acheter', en: 'To buy', phonetic: 'tuː baɪ', category: 'Verbes courants' },
  { id: 'w-verb-20', fr: 'Vendre', en: 'To sell', phonetic: 'tuː sɛl', category: 'Verbes courants' },
  { id: 'w-verb-21', fr: 'Aimer', en: 'To love / like', phonetic: 'tuː lʌv', category: 'Verbes courants' },
  { id: 'w-verb-22', fr: 'Comprendre', en: 'To understand', phonetic: 'tuː ˌʌndəˈstænd', category: 'Verbes courants' },
  { id: 'w-verb-23', fr: 'Apprendre', en: 'To learn', phonetic: 'tuː lɜːrn', category: 'Verbes courants' },
  { id: 'w-verb-24', fr: 'Essayer', en: 'To try', phonetic: 'tuː traɪ', category: 'Verbes courants' },

  // TECHNOLOGIE
  { id: 'w-tech-01', fr: 'Ordinateur', en: 'Computer', phonetic: 'kəmˈpjuːtər', category: 'Technologie' },
  { id: 'w-tech-02', fr: 'Téléphone', en: 'Phone', phonetic: 'foʊn', category: 'Technologie' },
  { id: 'w-tech-03', fr: 'Internet', en: 'Internet', phonetic: 'ˈɪntərˌnɛt', category: 'Technologie' },
  { id: 'w-tech-04', fr: 'Courriel', en: 'Email', phonetic: 'ˈiːmeɪl', category: 'Technologie' },
  { id: 'w-tech-05', fr: 'Mot de passe', en: 'Password', phonetic: 'ˈpæswɜːrd', category: 'Technologie' },
  { id: 'w-tech-06', fr: 'Réseau social', en: 'Social media', phonetic: 'ˈsoʊʃəl ˈmiːdiə', category: 'Technologie' },
  { id: 'w-tech-07', fr: 'Application', en: 'App', phonetic: 'æp', category: 'Technologie' },
  { id: 'w-tech-08', fr: 'Télécharger', en: 'Download', phonetic: 'ˈdaʊnloʊd', category: 'Technologie' },
  { id: 'w-tech-09', fr: 'Envoyer', en: 'Send', phonetic: 'sɛnd', category: 'Technologie' },
  { id: 'w-tech-10', fr: 'Écran', en: 'Screen', phonetic: 'skriːn', category: 'Technologie' },
  { id: 'w-tech-11', fr: 'Clavier', en: 'Keyboard', phonetic: 'ˈkiːbɔːrd', category: 'Technologie' },
  { id: 'w-tech-12', fr: 'Souris', en: 'Mouse', phonetic: 'maʊs', category: 'Technologie' },
  { id: 'w-tech-13', fr: 'Batterie', en: 'Battery', phonetic: 'ˈbætəri', category: 'Technologie' },
  { id: 'w-tech-14', fr: 'Chargeur', en: 'Charger', phonetic: 'ˈtʃɑːrdʒər', category: 'Technologie' },
  { id: 'w-tech-15', fr: 'Intelligence artificielle', en: 'Artificial intelligence', phonetic: 'ˌɑːrtɪˈfɪʃəl ɪnˈtɛlɪdʒəns', category: 'Technologie' },

  // SPORT
  { id: 'w-sport-01', fr: 'Football', en: 'Football / Soccer', phonetic: 'ˈfʊtbɔːl', category: 'Sport' },
  { id: 'w-sport-02', fr: 'Tennis', en: 'Tennis', phonetic: 'ˈtɛnɪs', category: 'Sport' },
  { id: 'w-sport-03', fr: 'Natation', en: 'Swimming', phonetic: 'ˈswɪmɪŋ', category: 'Sport' },
  { id: 'w-sport-04', fr: 'Course à pied', en: 'Running', phonetic: 'ˈrʌnɪŋ', category: 'Sport' },
  { id: 'w-sport-05', fr: 'Cyclisme', en: 'Cycling', phonetic: 'ˈsaɪklɪŋ', category: 'Sport' },
  { id: 'w-sport-06', fr: 'Ski', en: 'Skiing', phonetic: 'ˈskiːɪŋ', category: 'Sport' },
  { id: 'w-sport-07', fr: 'Randonnée', en: 'Hiking', phonetic: 'ˈhaɪkɪŋ', category: 'Sport' },
  { id: 'w-sport-08', fr: 'Yoga', en: 'Yoga', phonetic: 'ˈjoʊɡə', category: 'Sport' },
  { id: 'w-sport-09', fr: 'Équipe', en: 'Team', phonetic: 'tiːm', category: 'Sport' },
  { id: 'w-sport-10', fr: 'Entraîneur', en: 'Coach', phonetic: 'koʊtʃ', category: 'Sport' },
  { id: 'w-sport-11', fr: 'Stade', en: 'Stadium', phonetic: 'ˈsteɪdiəm', category: 'Sport' },
  { id: 'w-sport-12', fr: 'Championnat', en: 'Championship', phonetic: 'ˈtʃæmpiənʃɪp', category: 'Sport' },
  { id: 'w-sport-13', fr: 'Victoire', en: 'Victory', phonetic: 'ˈvɪktəri', category: 'Sport' },
  { id: 'w-sport-14', fr: 'Défaite', en: 'Defeat', phonetic: 'dɪˈfiːt', category: 'Sport' },
  { id: 'w-sport-15', fr: 'Arbitre', en: 'Referee', phonetic: 'ˌrɛfəˈriː', category: 'Sport' },

  // ÉCOLE
  { id: 'w-ecole-01', fr: 'École', en: 'School', phonetic: 'skuːl', category: 'École' },
  { id: 'w-ecole-02', fr: 'Université', en: 'University', phonetic: 'ˌjuːnɪˈvɜːrsɪti', category: 'École' },
  { id: 'w-ecole-03', fr: 'Professeur', en: 'Teacher', phonetic: 'ˈtiːtʃər', category: 'École' },
  { id: 'w-ecole-04', fr: 'Élève', en: 'Student', phonetic: 'ˈstjuːdənt', category: 'École' },
  { id: 'w-ecole-05', fr: 'Cours', en: 'Lesson / Class', phonetic: 'ˈlɛsən', category: 'École' },
  { id: 'w-ecole-06', fr: 'Devoir', en: 'Homework', phonetic: 'ˈhoʊmwɜːrk', category: 'École' },
  { id: 'w-ecole-07', fr: 'Examen', en: 'Exam', phonetic: 'ɪɡˈzæm', category: 'École' },
  { id: 'w-ecole-08', fr: 'Note', en: 'Grade / Mark', phonetic: 'ɡreɪd', category: 'École' },
  { id: 'w-ecole-09', fr: 'Livre', en: 'Book', phonetic: 'bʊk', category: 'École' },
  { id: 'w-ecole-10', fr: 'Stylo', en: 'Pen', phonetic: 'pɛn', category: 'École' },
  { id: 'w-ecole-11', fr: 'Crayon', en: 'Pencil', phonetic: 'ˈpɛnsɪl', category: 'École' },
  { id: 'w-ecole-12', fr: 'Tableau', en: 'Blackboard', phonetic: 'ˈblækbɔːrd', category: 'École' },
  { id: 'w-ecole-13', fr: 'Diplôme', en: 'Degree / Diploma', phonetic: 'dɪˈɡriː', category: 'École' },
  { id: 'w-ecole-14', fr: 'Bibliothèque', en: 'Library', phonetic: 'ˈlaɪbrəri', category: 'École' },
  { id: 'w-ecole-15', fr: 'Récréation', en: 'Break time', phonetic: 'breɪk taɪm', category: 'École' },
];

const CATEGORIES = [
  'Tous',
  'Salutations',
  'Voyage',
  'Nourriture',
  'Urgences',
  'Chiffres',
  'Travail',
  'Famille',
  'Temps',
  'Shopping',
  'Santé',
  'Transports',
  'Couleurs',
  'Corps humain',
  'Maison',
  'Nature',
  'Vêtements',
  'Adjectifs',
  'Verbes courants',
  'Technologie',
  'Sport',
  'École',
];

const CATEGORY_COLORS: Record<string, string> = {
  Salutations: 'bg-blue-100 text-blue-700',
  Voyage: 'bg-purple-100 text-purple-700',
  Nourriture: 'bg-orange-100 text-orange-700',
  Urgences: 'bg-red-100 text-red-700',
  Chiffres: 'bg-teal-100 text-teal-700',
  Travail: 'bg-indigo-100 text-indigo-700',
  Famille: 'bg-pink-100 text-pink-700',
  Temps: 'bg-yellow-100 text-yellow-700',
  Shopping: 'bg-green-100 text-green-700',
  Santé: 'bg-cyan-100 text-cyan-700',
  Transports: 'bg-slate-100 text-slate-700',
  Couleurs: 'bg-rose-100 text-rose-700',
  'Corps humain': 'bg-red-100 text-red-700',
  Maison: 'bg-amber-100 text-amber-700',
  Nature: 'bg-emerald-100 text-emerald-700',
  Vêtements: 'bg-violet-100 text-violet-700',
  Adjectifs: 'bg-sky-100 text-sky-700',
  'Verbes courants': 'bg-lime-100 text-lime-700',
  Technologie: 'bg-blue-100 text-blue-700',
  Sport: 'bg-orange-100 text-orange-700',
  École: 'bg-purple-100 text-purple-700',
};

export default function DictionaryClient() {
  const [direction, setDirection] = useState<'fr-en' | 'en-fr'>('fr-en');
  const [search, setSearch] = useState('');
  const [activeCategory, setActiveCategory] = useState('Tous');

  useEffect(() => {
    if (typeof window === 'undefined' || !window.speechSynthesis) return;
    const loadVoices = () => { window.speechSynthesis.getVoices(); };
    loadVoices();
    window.speechSynthesis.addEventListener('voiceschanged', loadVoices);
    return () => { window.speechSynthesis.removeEventListener('voiceschanged', loadVoices); };
  }, []);

  const speak = (text: string, lang: string = 'en-GB') => {
    if (typeof window === 'undefined' || !window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = lang;
    utterance.rate = 0.85;
    utterance.pitch = 1;
    const voices = window.speechSynthesis.getVoices();
    const match = voices.find((v) => v.lang.startsWith(lang.split('-')[0]));
    if (match) utterance.voice = match;
    window.speechSynthesis.speak(utterance);
  };

  const categoryCounts = useMemo(() => {
    const counts: Record<string, number> = { Tous: WORDS.length };
    WORDS.forEach((w) => {
      counts[w.category] = (counts[w.category] || 0) + 1;
    });
    return counts;
  }, []);

  const filtered = useMemo(() => {
    const q = search.toLowerCase().trim();
    return WORDS.filter((w) => {
      const matchCat = activeCategory === 'Tous' || w.category === activeCategory;
      if (!q) return matchCat;
      if (direction === 'fr-en') {
        return matchCat && (w.fr.toLowerCase().includes(q) || w.en.toLowerCase().includes(q));
      }
      return matchCat && (w.en.toLowerCase().includes(q) || w.fr.toLowerCase().includes(q));
    });
  }, [search, activeCategory, direction]);

  return (
    <section className="py-10 lg:py-14">
      <div className="max-w-screen-2xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-10">
        {/* Controls row */}
        <div className="flex flex-col sm:flex-row gap-3 mb-6">
          {/* Direction toggle */}
          <div className="flex rounded-xl border border-border overflow-hidden flex-shrink-0">
            <button
              onClick={() => setDirection('fr-en')}
              className={`px-4 py-2.5 text-sm font-semibold transition-colors ${
                direction === 'fr-en' ? 'pill-active' : 'pill-inactive'
              }`}
            >
              🇫🇷 FR → EN 🇬🇧
            </button>
            <button
              onClick={() => setDirection('en-fr')}
              className={`px-4 py-2.5 text-sm font-semibold transition-colors ${
                direction === 'en-fr' ? 'pill-active' : 'pill-inactive'
              }`}
            >
              🇬🇧 EN → FR 🇫🇷
            </button>
          </div>

          {/* Search */}
          <div className="relative flex-1">
            <svg className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="input-field pl-10"
              placeholder="Rechercher un mot..."
            />
            {search && (
              <button
                onClick={() => setSearch('')}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-primary"
                aria-label="Effacer la recherche"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
        </div>

        {/* Category pills */}
        <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-2 mb-8">
          {CATEGORIES.map((cat) => (
            <button
              key={`cat-pill-${cat}`}
              onClick={() => setActiveCategory(cat)}
              className={`flex-shrink-0 flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-sm transition-all duration-150 ${
                activeCategory === cat ? 'pill-active shadow-sm' : 'pill-inactive'
              }`}
            >
              {cat}
              <span className={`text-xs font-tabular ${activeCategory === cat ? 'opacity-80' : 'opacity-60'}`}>
                {categoryCounts[cat] || 0}
              </span>
            </button>
          ))}
        </div>

        {/* Results count */}
        <div className="flex items-center justify-between mb-5">
          <p className="text-sm text-muted-foreground">
            <span className="font-semibold text-primary font-tabular">{filtered.length}</span> mot{filtered.length !== 1 ? 's' : ''} trouvé{filtered.length !== 1 ? 's' : ''}
            {activeCategory !== 'Tous' && (
              <span> dans <span className="font-medium text-primary">{activeCategory}</span></span>
            )}
          </p>
          <p className="text-xs text-muted-foreground hidden sm:block">
            Cliquez sur 🔊 pour la prononciation phonétique
          </p>
        </div>

        {/* Word grid */}
        {filtered.length === 0 ? (
          <div className="text-center py-20">
            <div className="text-5xl mb-4">🔍</div>
            <h3 className="text-lg font-bold text-primary mb-2">Aucun mot trouvé</h3>
            <p className="text-sm text-secondary">
              Essayez un autre terme ou changez de catégorie.
            </p>
            <button
              onClick={() => { setSearch(''); setActiveCategory('Tous'); }}
              className="mt-4 px-5 py-2 btn-primary rounded-xl text-sm font-semibold"
            >
              Réinitialiser les filtres
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
            {filtered.map((word) => {
              const primaryWord = direction === 'fr-en' ? word.fr : word.en;
              const secondaryWord = direction === 'fr-en' ? word.en : word.fr;
              return (
                <div
                  key={word.id}
                  className="word-card-hover bg-white border border-border rounded-xl p-4 flex flex-col gap-2"
                >
                  {/* Category badge */}
                  <div className="flex items-center justify-between">
                    <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${CATEGORY_COLORS[word.category] || 'bg-muted text-secondary'}`}>
                      {word.category}
                    </span>
                    <button
                      onClick={() => speak(word.en, 'en-GB')}
                      className="w-7 h-7 rounded-lg bg-muted hover:bg-accent/10 flex items-center justify-center transition-colors group"
                      aria-label={`Prononciation de ${word.en}`}
                      title={`[${word.phonetic}]`}
                    >
                      <svg className="w-3.5 h-3.5 text-muted-foreground group-hover:text-accent transition-colors" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/>
                      </svg>
                    </button>
                  </div>

                  {/* Primary word */}
                  <div>
                    <p className="text-xl font-extrabold text-primary leading-tight">{primaryWord}</p>
                    <p className="text-base font-semibold text-accent mt-0.5">{secondaryWord}</p>
                  </div>

                  {/* Phonetic */}
                  <p className="text-xs text-muted-foreground font-mono">[{word.phonetic}]</p>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}